/**
 * Immediate domain detection without depending on useSettings hook
 * This ensures menu filtering works on first render before settings load
 */
export function useImmediateDomainCheck() {
  const getCurrentDomain = (): string => {
    if (typeof window === 'undefined') return '';
    return window.location.host;
  };

  const getMainDomain = (): string => {
    if (typeof window === 'undefined') return '';
    
    // First try to get from meta tag (set by backend from config)
    const appDomainMeta = document.querySelector('meta[name="app-domain"]');
    if (appDomainMeta) {
      const metaDomain = appDomainMeta.getAttribute('content');
      if (metaDomain) {
        return metaDomain;
      }
    }
    
    // Fallback: Try to extract from current URL or use localhost
    try {
      const currentUrl = window.location.origin;
      const urlObj = new URL(currentUrl);
      const fallbackDomain = urlObj.hostname;
      return fallbackDomain;
    } catch (error) {
      return 'localhost';
    }
  };

  const isMainDomain = (): boolean => {
    const currentHost = getCurrentDomain();
    const mainHost = getMainDomain();
    
    const isMain = currentHost === mainHost || currentHost === `www.${mainHost}`;
  
    
    return isMain;
  };

  const isTenantDomain = (): boolean => {
    return !isMainDomain();
  };

  return {
    getCurrentDomain,
    getMainDomain,
    isMainDomain,
    isTenantDomain
  };
}